var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-StandardActivities",
    transform: "translate(-589.000000, -162.000000)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tags",
    transform: "translate(546.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-filter",
    transform: "translate(43.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25,6.25 L3.125,10 L0,6.25 L6.25,6.25 Z M3.125,0 L6.25,3.75 L0,3.75 L3.125,0 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilter);
export default __webpack_public_path__ + "static/media/ic-filter.c375f408428d1e822d1eb7b9ac351610.svg";
export { ForwardRef as ReactComponent };